module.exports = __webpack_public_path__ + "static/media/p1_1.51ec8943.png";